const _ = require('lodash');
var ADLER32 = require('adler-32');

const funcs = {
  scrollToY: function (y, bodyAndWindowHandles, offset, zoom) {
    var { windowHandle } = bodyAndWindowHandles;
    windowHandle.scrollTo({
      'behavior': 'smooth',
      'left': 0,
      'top': (zoom / 100) * (y + offset)
    });
  },
  pageDisplay: function (metadata, oneBasedIndex) {
    if (metadata.pages && metadata.pages.length > 0) {
      var page = _.find(metadata.pages, function (page) {
        return page.page === oneBasedIndex;
      })

      if (page) {
        return page.title;
      } else {
        return metadata.pages[0].title;
      }
    }
    return "";
  },
  pageOneBasedIndex: function (metadata, pageDisplay, navigation) {
    if (metadata && metadata.pages && metadata.pages.length > 0) {
      var page;

      if (navigation === "prevNavPage"){
        page = _.findLast(metadata.pages, function (page) {
          return page.title === pageDisplay;
        })
      } else {
        page = _.find(metadata.pages, function (page) {
          return page.title === pageDisplay;
        })
      }
      if (page) {
        return page.page;
      } else {
        return metadata.pages[0].page;
      }
    }
    return "";
  },
  getPDFPageTopAndBottom(pageOneBasedIndex) {
    var el = document.getElementById("page-" + (pageOneBasedIndex));
    if (el) {
      const { offsetTop, offsetHeight } = el;
      var top = offsetTop;
      var bottom = offsetTop + offsetHeight;
      return { top, bottom };
    }

    return undefined;
  },
  isPDF(book) {
    return book.format === 'mpdf'
  },
  isMPUB(book) {
    return book.format === 'mpub'
  },
  getCurrentPageObject(metadata, currentPage) {
    var currentPageObject = metadata.pages[currentPage.oneBasedIndex - 1];
    if (!currentPageObject) {
      currentPageObject = metadata.pages[0];
    }
    return currentPageObject;
  },
  getiFrame() {
    return funcs.getiFrameWithSelector('.book-view-container iframe');
  },
  getiFrameWithSelector(selector) {
    var bodyHandle, windowHandle, documentHandle;
    document.querySelectorAll(selector).forEach(item => {
      bodyHandle = item.contentWindow.document.body ? item.contentWindow.document.body : item.contentWindow.document.documentElement;
      documentHandle = item.contentWindow.document
      windowHandle = item.contentWindow;
    })

    return { bodyHandle, windowHandle, documentHandle }
    // for non-iframe use {bodyHandle: document, windowHandle: window}
  },
  getSummaryiFrame() {
    return funcs.getiFrameWithSelector('#summary-display');
  },
  isValidPageRange(book, metadata, fromPageDisplay, toPageDisplay) {

    var fromPage, toPage = -1;

    if(funcs.isMPUB(book)) {
      fromPage = _.findIndex(metadata.pages, page => fromPageDisplay === page.page);
      toPage = _.findIndex(metadata.pages, page => toPageDisplay === page.page);
    } else {
      fromPage = _.findIndex(metadata.pages, page => fromPageDisplay === page.title);
      toPage = _.findIndex(metadata.pages, page => toPageDisplay === page.title);
    }

    return fromPage != -1 && toPage != -1 && fromPage <= toPage;
  },
  getSectionsFromPageRange(book, metadata, fromPageDisplay, toPageDisplay) {
    var sections = [];

    
    if (funcs.isMPUB(book)) {
      var fromPage = _.findIndex(metadata.pages, page => fromPageDisplay === page.page);
      var toPage = _.findIndex(metadata.pages, page => toPageDisplay === page.page);

      for (var i = fromPage; i <= toPage; i++) {
        sections.push(metadata.pages[i].file);
      }

      sections = _.uniq(sections);
    } else {
      var fromPage = _.findIndex(metadata.pages, page => fromPageDisplay === page.title);
      var toPage = _.findIndex(metadata.pages, page => toPageDisplay === page.title);

      for (var i = fromPage; i <= toPage; i++) {
        sections.push("" + (i + 1));
      }
    }

    return sections;
  },
  getPageFromFile(metadata, file, type) {
    if (type === "mpub") {
      var pageInfo = _.find(metadata.pages, function (page) {
        return page.file === file;
      });

      return pageInfo && pageInfo.page ? pageInfo.page : metadata.pages[0].page;
    } else {

      var pageInfo = _.find(metadata.pages, function (page) {
        return page.page.toString() === file;
      });

      return pageInfo && pageInfo.page ? pageInfo.title : metadata.pages[0].title;
    }
  },
  constructHLId(section, book) {
    function padAdler(adler, width) {
      adler = adler + '';
      return adler.length >= width ? adler : new Array(width - adler.length + 1).join("0") + adler;
    }
    const sectionEncoded = section.length <= 8 ? section : ADLER32.str(section);
    const bookEncoded = padAdler(ADLER32.str(book), 8);
    return "hl2-" + bookEncoded + "-" + sectionEncoded
  },
  getMPUBPageRange(metadata, file) {
    var pages = _.filter(metadata.pages, page => {
      return page.file === file;
    })
    pages = pages.map(item => item.page)
    return [Math.min(...pages), Math.max(...pages)];
  }
}

export default funcs
